<div fxLayout="column" fxFlex="100" fxLayoutGap="10">
    <h2>{{'admin-center.employee.associatedEmployees' | translate}}</h2>
    
    <button type="button" kendoButton (click)="associateEmployee()" icon="plus" type="submit"> 
        {{'global.add' | translate}}
    </button>
    
    <div *ngFor="let associatedEmployee of associatedEmployees$ |async" class="form-block">
        <div fxLayout="row" fxFlex="100">

            <button kendoButton look="flat" icon="delete" (click)="removeEmployeeAssociation(associatedEmployee.id)"> </button>
            <div fxLayout="column">
                <strong> {{associatedEmployee.name}} {{associatedEmployee.surname}}</strong>
                <span>{{associatedEmployee.position}}</span>

            </div>
        </div>
    </div>
</div>

<div kendoDialogContainer #employeeSelectionForAssociationDialog></div>